import { jwtDecode } from 'jwt-decode';
import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { Button, Card, CardBody, Col, Container, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Table } from 'reactstrap';
import Swal from 'sweetalert2';
import useDelete from '../../hooks/useDelete';
import useGet from '../../hooks/useGet';
import usePost from '../../hooks/usePost';
import Breadcrumbs from '../../layout/breadcrumb';
import Loader from '../../layout/loader';

export default function GrossisteList() {
  const token = document.cookie.split(`jwt=`).pop().split(';').shift();
  const user_id = token.length > 0 ? jwtDecode(token).id : "";
  const [Verticalcenter, setVerticalcenter] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("")
  const [grossisteList, setGrossisteList] = useState([])
  const Verticalcentermodaltoggle = () => { setVerticalcenter(!Verticalcenter) };
  const [grossisteDetails, setGrossiteDetails] = useState({
    grossiste_name: "",
    grossiste_reseau: "",
    grossiste_wilaya: "",
    grossiste_phone: "",
    grossiste_region: "",
    grossiste_commune: "",
    grossiste_id: "",
  });

  const { mutate: getGrossisteList, isLoading: isLoadingGet } = useGet( 'grossiste', {
    onSuccess: async (fetched) => {
      setGrossisteList(fetched)
    },
    onError: (error) => {
      const message = error?.response?.data?.message || "An error occurred!";
      toast.error(message);
    }
  });
  const { mutate: deleteGrossiste, isLoading: isLoadingDelete } = useDelete('/grossiste/delete', {
    onSuccess: (data) => {
      toast.error("Deleted successfully");
    },
    onError: (error) => {
      const message = error?.response?.data || "An error occurred!";
      toast.error(message);
    }
  });
  const { mutate: createGrossiste, isLoading: isLoadingCreate } = usePost("/grossiste/new", {
    onSuccess: (data) => {
      toast.success(data);
    },
    onError: (error) => {
      const message = error?.response?.data || "An error occurred!";
      toast.error(message);
    }
  });

  const filtredList = Array.isArray(grossisteList)
    ? searchKeyword
      ? grossisteList.filter((user) => {
        const grossisteName = user.grossiste_name.toLowerCase() || "";
        const commune = user.grossiste_commune.toLowerCase() || "";
        const wilaya = user.grossiste_wilaya.toLowerCase() || "";
        const region = user.grossiste_region.toLowerCase() || "";
        return grossisteName.includes(searchKeyword.toLowerCase()) || commune.includes(searchKeyword.toLowerCase()) || wilaya.includes(searchKeyword.toLowerCase()) || region.includes(searchKeyword.toLowerCase());
      })
      : grossisteList
    : [];

  const confirmDelete = (grossiste_id) => {
    Swal.fire({
      title: "Voulez vous vraiment supprimer le grossiste ?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Supprimer",
      denyButtonText: `Annuler`
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        deleteGrossiste({ grossiste_id: grossiste_id })
      } else if (result.isDenied) {
        return
      }
    });
  }

  useEffect(() => {
    getGrossisteList(`/grossiste/all?user_id=${user_id}`)
  }, [])


  if (isLoadingDelete) return <Loader isLoading={isLoadingDelete} />
  if (isLoadingGet) return <Loader isLoading={isLoadingGet} />
  if (isLoadingCreate) return <Loader isLoading={isLoadingGet} />

  return (
    <Fragment>
      <Breadcrumbs parent="Grossiste" title="Grossiste" />

      <Container fluid={true} className='pb-4 mb-4'>
        <Row>
          <Col>
            <Button color='dark' onClick={() => { Verticalcentermodaltoggle() }}>
              Ajouter
            </Button>
          </Col>
          <Col md={"3"} lg="6" className='f-right feature-products'>
            <Form onSubmit={(e) => e.preventDefault()}>
              <FormGroup>
                <Input
                  className="form-control"
                  type="text"
                  placeholder="Nom du grossiste"
                  value={searchKeyword}
                  style={{
                    border: "1px solid #000000",
                  }}
                  onChange={(e) => setSearchKeyword(e.target.value)}
                />
              </FormGroup>
            </Form>
          </Col>
        </Row>
        <br />

        {grossisteList && filtredList.length === 0 ?
          <Card className='text-align-center'>
            <CardBody style={{ textAlign: "center" }}>
              <h4>Aucun Grossiste à afficher</h4>
            </CardBody>
          </Card>
          :
          <>
            <Row>
              <Col xs={12} className='o-auto'>
                <Table style={{ background: "white" }}>
                  <thead>
                    <tr className='text-center'>
                      <th>#</th>
                      <th>Name</th>
                      <th>Reseau</th>
                      <th>Phone</th>
                      <th>Region</th>
                      <th>Wilaya</th>
                      <th>Commune</th>
                      {/* <th>KAM users</th> */}
                      {/* <th>Superviseur</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {grossisteList && filtredList.map((grossiste) => {
                      return (
                        <tr key={filtredList.indexOf(grossiste)} className='text-center'>
                          <th scope='row'> {(filtredList.indexOf(grossiste) + 1)}</th>
                          <td>{grossiste.grossiste_name}</td>
                          <td>{grossiste.grossiste_reseau}</td>
                          <td>{grossiste.grossiste_phone}</td>
                          <td>{grossiste.grossiste_region}</td>
                          <td>{grossiste.grossiste_wilaya}</td>
                          <td>{grossiste.grossiste_commune}</td>
                          <td style={{ textAlign: "center" }}>
                            <Link to={{
                              pathname: `/grossiste/detailed`,
                            }}
                              state={{
                                grossiste: grossiste,
                              }}
                            >
                              <i className="fa fa-table mr-2" id="TooltipExample"></i>
                            </Link>
                            <i className="fa fa-trash text-danger ml-2" id="TooltipExample" style={{ cursor: "pointer" }} onClick={() => confirmDelete(grossiste.grossiste_id)}></i>
                          </td>
                        </tr>
                      )
                    })
                    }
                  </tbody>
                </Table>
                <Modal isOpen={Verticalcenter} toggle={Verticalcentermodaltoggle} centered>
                  <ModalHeader toggle={Verticalcentermodaltoggle}>
                    Ajouter Grossiste
                  </ModalHeader>
                  <ModalBody>
                    <Row>
                      <Col md="12" className='input--group'>
                        <FormGroup>
                          <Label className="form-label" >Nom: </Label>
                          <Input type="text" className="form-control" placeholder="Nom" onChange={(e) => { setGrossiteDetails({ ...grossisteDetails, grossiste_name: e.target.value }) }} />
                        </FormGroup>
                        <FormGroup>
                          <Label className="form-label" >Wilaya: </Label>
                          <Input type="text" className="form-control" placeholder="Wilaya" onChange={(e) => { setGrossiteDetails({ ...grossisteDetails, grossiste_wilaya: e.target.value }) }} />
                        </FormGroup>
                        <FormGroup>
                          <Label className="form-label" >Commune: </Label>
                          <Input type="text" className="form-control" placeholder="Commune" onChange={(e) => { setGrossiteDetails({ ...grossisteDetails, grossiste_commune: e.target.value }) }} />
                        </FormGroup>
                        <FormGroup>
                          <Label className="form-label" >Region: </Label>
                          <Input type="text" className="form-control" placeholder="Region" onChange={(e) => { setGrossiteDetails({ ...grossisteDetails, grossiste_region: e.target.value }) }} />
                        </FormGroup>
                        <FormGroup>
                          <Label className="form-label" >Phone: </Label>
                          <Input type="text" className="form-control" placeholder="Phone" onChange={(e) => { setGrossiteDetails({ ...grossisteDetails, grossiste_phone: e.target.value }) }} />
                        </FormGroup>
                        <FormGroup>
                          <Label className="form-label" >Reseau: </Label>
                          <input type="text" className="form-control" placeholder="Reseau" onChange={(e) => { setGrossiteDetails({ ...grossisteDetails, grossiste_reseau: e.target.value }) }} />
                        </FormGroup>
                      </Col>
                    </Row>
                  </ModalBody>
                  <ModalFooter className='d-block'>
                    <Row>
                      <Col>
                        <Button color='dark' onClick={() => {
                          createGrossiste({
                            grossiste_name: grossisteDetails.grossiste_name,
                            grossiste_region: grossisteDetails.grossiste_region,
                            grossiste_commune: grossisteDetails.grossiste_commune,
                            grossiste_wilaya: grossisteDetails.grossiste_wilaya,
                            grossiste_reseau: grossisteDetails.grossiste_reseau,
                            grossiste_phone: grossisteDetails.grossiste_phone,
                            grossiste_id: grossisteDetails.grossiste_id
                          })
                          getGrossisteList()
                          setVerticalcenter(false);
                        }}>
                          Ajouter
                        </Button>
                      </Col>
                    </Row>
                  </ModalFooter>
                </Modal>
              </Col>
            </Row>

          </>
        }

      </Container>
    </Fragment>
  )
}
